import Head from 'next/head'
import Page from '../components/Page'
import Header from '../components/Header'
import Footer from '../components/Footer'
import CommonHeadTags from '../components/CommonHeadTags'
import {
  GoogleAnalyticsHead,
  GoogleAnalyticsBody,
} from '../components/GoogleAnalytics'
import withLocale from '../translations/withLocale'
import useTranslation from '../translations/useTranslation'
import { nonEnglishLocales, localeHreflangs } from '../translations/config'

function BassGuitar() {
  const { t } = useTranslation()
  return (
    <>
      <Head>
        <title>{t('title-bass-guitar')}</title>
        <meta
          name='description'
          content={t('description-bass-guitar')}
        />
        <meta httpEquiv='content-language' content='en' />
        <link
          rel='canonical'
          href='https://guitar-tuner.org/bass-guitar-tuning'
        />
        <link
          rel='alternate'
          hrefLang='x-default'
          href='https://guitar-tuner.org/bass-guitar-tuning'
        />
        <link
          rel='alternate'
          hrefLang='en'
          href='https://guitar-tuner.org/bass-guitar-tuning'
        />
        {nonEnglishLocales.map((locale) => (
          <link
            key={locale}
            rel='alternate'
            hrefLang={localeHreflangs[locale]}
            href={`https://guitar-tuner.org/${locale}/bass-guitar-tuning`}
          />
        ))}
        <CommonHeadTags
          title={t('title-bass-guitar')}
          description={t('description-bass-guitar')}
          url='https://guitar-tuner.org/bass-guitar-tuning'
        />
        <GoogleAnalyticsHead />
      </Head>

      <Header instrument='bass-guitar'/>

      <main>
        <Page
          instrument='bass-guitar'
          pageData='bass-guitar-tuning'
        />
      </main>

      <Footer />
      <GoogleAnalyticsBody />
    </>
  )
}

export default withLocale(BassGuitar)
